import React from 'react';
import PropTypes from 'prop-types';
import ARManagementList from './ARManagementList';

const TabARManagement = (props) => {
    const { departmentFilter, thereapeuticClassFilter, specialtyTypeFilter, customerId, userFullname } = props;
    return (
        <>
            <ARManagementList
                thereapeuticClassFilter={thereapeuticClassFilter}
                departmentFilter={departmentFilter}
                specialtyTypeFilter={specialtyTypeFilter}
                customerId={customerId}
                userFullname={userFullname}
            />
        </>
    );
};

TabARManagement.propTypes = {
    departmentFilter: PropTypes.object.isRequired,
    thereapeuticClassFilter: PropTypes.object.isRequired,
    specialtyTypeFilter: PropTypes.func.isRequired,
    userFullname: PropTypes.object.isRequired,
    customerId: PropTypes.object.isRequired,
};

export default TabARManagement;
